export default "__VITE_ASSET__B7oLk_kt__"